/** Extrae el texto legible de una ubicación asociada al puesto (la API puede devolver `code` plano o anidado en `location`). */
export function resolvePackingStationLocationCode(raw: unknown): string {
  if (!raw || typeof raw !== 'object') return '';
  const r = raw as Record<string, unknown>;

  const asTrimmedString = (v: unknown): string => {
    if (typeof v === 'string') return v.trim();
    if (v == null) return '';
    const s = String(v).trim();
    return s === 'null' || s === 'undefined' ? '' : s;
  };

  const nested = (r.location ?? r.warehouse_location ?? r.warehouseLocation) as Record<string, unknown> | undefined;
  const fromNested =
    nested && typeof nested === 'object'
      ? asTrimmedString(nested.code) || asTrimmedString(nested.name) || asTrimmedString(nested.label)
      : '';

  const attrs = r.attributes as Record<string, unknown> | undefined;
  const fromAttrs =
    attrs && typeof attrs === 'object'
      ? asTrimmedString(attrs.code) || asTrimmedString(attrs.name) || asTrimmedString(attrs.label)
      : '';

  return (
    asTrimmedString(r.code) ||
    asTrimmedString(r.location_code) ||
    asTrimmedString(r.locationCode) ||
    asTrimmedString(r.name) ||
    asTrimmedString(r.label) ||
    fromNested ||
    fromAttrs
  );
}
